class Pais {
  constructor(dados) {
    this.id = dados.id;
    this.nome = dados.nome;
    this.sigla = dados.sigla;
    this.ddi = dados.ddi;
    this.gentilico = dados.gentilico;
  }
}
export default Pais;
